module.exports = __webpack_public_path__ + "static/media/deliciouswobster.d2968600.webp";